/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Item,
  Item$inboundSchema,
  Item$Outbound,
  Item$outboundSchema,
} from "./item.js";

export type CreateConversationRequest = {
  /**
   * Initial items to include in the conversation context. Max 20 items at a time.
   */
  items?: Array<Item> | undefined;
  /**
   * Set of 16 key-value pairs for storing additional information.
   */
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const CreateConversationRequest$inboundSchema: z.ZodType<
  CreateConversationRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  items: z.array(Item$inboundSchema).optional(),
  metadata: z.record(z.string()).optional(),
});
/** @internal */
export type CreateConversationRequest$Outbound = {
  items?: Array<Item$Outbound> | undefined;
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const CreateConversationRequest$outboundSchema: z.ZodType<
  CreateConversationRequest$Outbound,
  z.ZodTypeDef,
  CreateConversationRequest
> = z.object({
  items: z.array(Item$outboundSchema).optional(),
  metadata: z.record(z.string()).optional(),
});

export function createConversationRequestToJSON(
  createConversationRequest: CreateConversationRequest,
): string {
  return JSON.stringify(
    CreateConversationRequest$outboundSchema.parse(createConversationRequest),
  );
}
export function createConversationRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateConversationRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateConversationRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateConversationRequest' from JSON`,
  );
}
